import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUser, LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsDialogService } from '../../../services/cms.dialog.service';
import { CmsHelpService } from '../../../services/cms.help.service';

type HelpTendersTab = 'overview' | 'matches' | 'search' | 'bookmarks';

@Component({
    selector: 'help-tenders',
    template: require('./help.tenders.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.tenders.component.css')]
})
export class HelpTendersComponent implements OnInit, OnDestroy {
    private readonly tabOrder: HelpTendersTab[] = ['overview', 'matches', 'search', 'bookmarks'];
    private readonly dialogPrefixes: Record<Exclude<HelpTendersTab, 'overview'>, string> = {
        matches: 'Matching Tenders Info',
        search: 'Search Tenders Info',
        bookmarks: 'Bookmarked Tenders Info'
    };

    selectedTabIndex = 0;
    overviewContent = '';
    matchesContent = '';
    matchesHeader = '';
    searchContent = '';
    searchHeader = '';
    bookmarksContent = '';
    bookmarksHeader = '';

    private subscribed: boolean;
    private loggedInUser: LoggedInUser;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly cmsHelpService: CmsHelpService,
        private readonly cmsDialogService: CmsDialogService,
        userService: LoggedInUserService) {
        this.loggedInUser = userService.getCurrentUser();
        this.subscribed = !this.loggedInUser.canAdHoc('notSubscribed');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        this.route.queryParams.subscribe(params => {
            const tab = this.normalizeTab((params && params.tab ? params.tab : '').toString());
            this.selectedTabIndex = this.tabOrder.indexOf(tab);
            if (this.selectedTabIndex < 0) {
                this.selectedTabIndex = 0;
            }
        });

        this.cmsHelpService.getByUser(this.loggedInUser.userId).subscribe((result: any) => {
            this.overviewContent = result.content || '';
        });

        this.loadDialogTab('matches', 'matchesHeader', 'matchesContent');
        this.loadDialogTab('search', 'searchHeader', 'searchContent');
        this.loadDialogTab('bookmarks', 'bookmarksHeader', 'bookmarksContent');
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    onTabChange(index: number) {
        const tab = this.tabOrder[index] || 'overview';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private normalizeTab(tab: string): HelpTendersTab {
        if (tab === 'matches' || tab === 'search' || tab === 'bookmarks' || tab === 'overview') {
            return tab;
        }
        return 'overview';
    }

    private loadDialogTab(
        tab: Exclude<HelpTendersTab, 'overview'>,
        headerField: 'matchesHeader' | 'searchHeader' | 'bookmarksHeader',
        contentField: 'matchesContent' | 'searchContent' | 'bookmarksContent') {
        const suffix = this.subscribed ? 'Subscribed' : 'Not Subscribed';
        const description = !this.subscribed && tab === 'bookmarks'
            ? 'Bookmarked Tenders'
            : `${this.dialogPrefixes[tab]} - ${suffix}`;

        this.cmsDialogService.getByDescription(description).subscribe((result: CmsDialogDto) => {
            this[headerField] = result.header || '';
            this[contentField] = result.body || '';
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.tenders.component.ts